import React from "react";

// Authentic inline SVG brand marks for each social platform.
// Sized via the `size` prop (default 20). Each component sets its own viewBox.
// These are simplified, recognizable interpretations of public brand marks intended
// for prototype mockup use only.

export function LinkedInLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="4" fill="#0A66C2" />
      <path
        fill="#fff"
        d="M11.7 12.6H8.2v11.1h3.5V12.6Zm.2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm12.3 8.6c0-3-1.6-4.5-3.8-4.5-1.7 0-2.5.9-3 1.6v-1.3h-3.5c.1 1 0 11.1 0 11.1h3.5v-6.2c0-.3 0-.6.1-.9.3-.6.8-1.3 1.8-1.3 1.3 0 1.8 1 1.8 2.4v6h3.1v-6.9Z"
      />
    </svg>
  );
}

export function XLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
      <path
        fill="currentColor"
        d="M18.244 2H21.5l-7.46 8.523L23 22h-6.844l-5.36-7.01L4.6 22H1.34l7.98-9.122L1 2h7.02l4.844 6.412L18.244 2Zm-1.198 18h1.83L7.04 4h-1.96l11.966 16Z"
      />
    </svg>
  );
}

export function InstagramLogo({ size = 20, className = "" }) {
  const gid = `ig-grad-${Math.random().toString(36).slice(2, 7)}`;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <defs>
        <radialGradient id={gid} cx="0.3" cy="1.05" r="1.2">
          <stop offset="0%" stopColor="#F9CE34" />
          <stop offset="45%" stopColor="#EE2A7B" />
          <stop offset="100%" stopColor="#6228D7" />
        </radialGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${gid})`} />
      <rect x="7.5" y="7.5" width="17" height="17" rx="5" fill="none" stroke="#fff" strokeWidth="2" />
      <circle cx="16" cy="16" r="4.2" fill="none" stroke="#fff" strokeWidth="2" />
      <circle cx="21.5" cy="10.5" r="1.2" fill="#fff" />
    </svg>
  );
}

export function FacebookLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <circle cx="16" cy="16" r="16" fill="#1877F2" />
      <path
        fill="#fff"
        d="M21.4 20.5l.7-4.5h-4.3v-2.9c0-1.2.6-2.4 2.6-2.4h2V7c-1.2-.2-2.4-.3-3.5-.3-3.6 0-5.9 2.2-5.9 6.1v3.5H8.9V20.5h4V32h4.9V20.5h3.6Z"
      />
    </svg>
  );
}

export function ThreadsLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 192 192" className={className} aria-hidden>
      <path
        fill="currentColor"
        d="M141 88.8c-.7-.3-1.4-.6-2.2-1-1.3-23.4-14-36.8-35.3-37h-.3c-12.7 0-23.3 5.4-29.8 15.3l11.7 8c4.9-7.4 12.6-9 18.1-9h.2c6.9.1 12.1 2 15.4 5.9 2.4 2.8 4 6.7 4.8 11.6-6.1-1-12.6-1.3-19.6-.9-19.7 1.1-32.4 12.6-31.5 28.6.5 8.1 4.5 15.1 11.4 19.6 5.8 3.9 13.3 5.8 21.1 5.4 10.3-.6 18.4-4.5 24-11.7 4.3-5.5 7-12.6 8.2-21.5 4.9 3 8.5 6.9 10.5 11.6 3.4 8 3.6 21.1-7 31.7-9.3 9.3-20.5 13.3-37.4 13.5-18.7-.1-32.9-6.1-42.1-17.9C57 130 52.5 116.4 52.4 96c.1-20.4 4.6-34 13.1-44.9C74.7 39.3 88.9 33.3 107.6 33.2c18.9.1 33.3 6.2 42.9 18 4.7 5.8 8.2 13 10.6 21.5l13.6-3.6c-2.9-10.4-7.4-19.4-13.6-26.9C148.6 26.9 130.7 18.3 107.6 18.2h-.1c-23 .2-40.7 8.8-52.7 25.7-10.6 15-16.1 35.8-16.3 61.8v.2c.2 26 5.7 46.8 16.3 61.8 12 16.9 29.7 25.5 52.7 25.7h.1c20.4-.1 34.8-5.5 46.7-17.4 15.5-15.5 15-34.9 9.9-46.8-3.7-8.6-10.6-15.5-19.7-19.7Zm-36.1 17.9c-8.6.5-17.6-3.4-18.1-11.6-.3-6.1 4.3-12.8 18.6-13.6 1.6-.1 3.2-.1 4.8-.1 5.2 0 10.1.5 14.6 1.4-1.7 21.2-11.6 23.4-19.8 23.9z"
      />
    </svg>
  );
}

export function BlueskyLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 57" className={className} aria-hidden>
      <path
        fill="#1185FE"
        d="M13.873 3.805C21.21 9.332 29.103 20.537 32 26.55c2.897-6.013 10.79-17.218 18.127-22.745C55.42-.183 64-3.061 64 6.726c0 1.954-1.12 16.408-1.777 18.747-2.283 8.135-10.583 10.213-17.961 8.957 12.9 2.196 16.182 9.469 9.091 16.741-13.469 13.811-19.358-3.464-20.867-7.913-.27-.812-.405-1.222-.486-.876-.081-.346-.216.064-.486.876-1.509 4.449-7.398 21.724-20.867 7.913-7.09-7.272-3.809-14.545 9.091-16.741-7.378 1.256-15.678-.822-17.961-8.957C1.12 23.134 0 8.68 0 6.726 0-3.061 8.58-.183 13.873 3.805Z"
      />
    </svg>
  );
}

export function YouTubeLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="8" fill="#FF0000" />
      <path fill="#fff" d="M13 11l9 5-9 5z" />
    </svg>
  );
}

export function ShortsLogo({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="8" fill="#FF0033" />
      <path
        fill="#fff"
        d="M21.7 11.8c1.5.9 1.4 3.1-.2 3.8L19 17l2.5 1.4c1.6.7 1.7 2.9.2 3.8L13 27.2c-1.5.9-3.4-.2-3.4-2v-3l-1.5.9c-1.5.9-3.4-.2-3.4-2V10.9c0-1.8 1.9-2.9 3.4-2L9.6 10v-3c0-1.8 1.9-2.9 3.4-2l8.7 6.8Z"
      />
    </svg>
  );
}

export const PLATFORM_LOGO = {
  linkedin: LinkedInLogo,
  x: XLogo,
  twitter: XLogo,
  instagram: InstagramLogo,
  facebook: FacebookLogo,
  threads: ThreadsLogo,
  bluesky: BlueskyLogo,
  youtube: YouTubeLogo,
  youtube_shorts: ShortsLogo,
};
